import { Grid, Box, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  ArrowButton,
  Item,
  WsColors,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import Monster from '../../../../../images/jobBoardsIcons/Monster.png';
import NativeSearchSettings from '../../../NativeSearchSettings';
import NewAccount from '../../nativeSearchIndex/NewAccount';

export const NativeDialogHeader = styled(Item)(({ theme }) => ({
  backgroundColor: WsColors.TheBlues50,
  padding: theme.spacing(1),
}));

const MonsterNewAccount = () => {
  const navigate = useNavigate();

  return (
    <NativeSearchSettings>
      <Box>
        <NativeDialogHeader>
          <Grid item xs={12} container justifyContent="flex-start" columnGap={2}>
            <ArrowButton title="" onClick={() => navigate('/native-search-settings/monster')} />
            <img src={Monster} alt="Monster" height="35" />
            <WsTypography variant={WsTypoVariants.SUB_TITLE}>Add new Monster account</WsTypography>
          </Grid>
        </NativeDialogHeader>
        <Box bgcolor="white" p={3}>
          <Grid item xs={12} pl={2}>
            <WsTypography color={WsTypoColors.SECONDARY} variant={WsTypoVariants.SUB_TITLE}>
              Add account by configuring Monster account using RTP credentials.
            </WsTypography>
          </Grid>
          <NewAccount accountType={'MONSTER'} />
        </Box>
      </Box>
    </NativeSearchSettings>
  );
};

export default MonsterNewAccount;
